module.exports = __webpack_public_path__ + "static/img/1_1_1.af5c0b63.jpg";